import React, { FC } from 'react';
import { TextField } from '@mui/material';
import { Button } from '@components';
import { textLengthValidator } from '@helpers';
import { setClass } from '@utils';
import { isMobile } from 'react-device-detect';
import '../../../../../styles/components/nameBlock.scss';

interface TextInfoBlockProp {
  name: string;
  onCreateMeeting: () => void;
  onUpdateMeeting: (property: 'meetingName', value: string) => void;
  isEdit?: boolean;
  showError: boolean;
  saveDisabled: boolean;
}

export const NameBlock: FC<TextInfoBlockProp> = ({
  name, onCreateMeeting, onUpdateMeeting, isEdit, showError, saveDisabled,
}) => {
  const onEditName = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    onUpdateMeeting('meetingName', event.target.value);
  };
  const MAX_LENGTH_OF_NAME = 55;
  const helperText = (meetingName: string) => {
    if (!meetingName) {
      return 'Введите название встречи';
    } else if (!textLengthValidator(meetingName, MAX_LENGTH_OF_NAME)) {
      return 'Превышен максимальный размер поля в 55 символов';
    }
    return '';
  };
  return (
    <div className={setClass('area meeting-name', isMobile && 'mobile')}>
      {isEdit
        ? (
          <>
            {isMobile && (
              <div className="name-circle" />
            )}
            <TextField
              className={setClass('text-field', isMobile && 'mobile')}
              placeholder="Добавить название *"
              variant="standard"
              value={name}
              onChange={onEditName}
              error={showError && (!name || !textLengthValidator(name, MAX_LENGTH_OF_NAME))}
              helperText={showError && helperText(name)}
              autoFocus

            />
            {!isMobile && (
              <Button
                title="Сохранить"
                className="button"
                onClick={onCreateMeeting}
                disabled={saveDisabled}
              />
            )}
          </>
        )
        : <p className="view-meeting-name">{name}</p>}
    </div>
  );
};
